import RiskFactor from './RiskFactor';

export * from './RiskFactor';

export default RiskFactor;
